// DataCard.jsx

import React from 'react';
import {
    DataCardContainer,
    DataCardTitle,
    DataCardValue,
    MinMaxContainer,
    MinMaxValue,
} from './DataCardStyle';
import NoDataMessage from '../NoDataMessage/NoDataMessage';
import { formatDecimalText, formatNumber } from '../../utils/generalUtils';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

const DataCard = ({
                      title,
                      children,
                      min,
                      max,
                      icon,
                      color,
                      smallVersion = false // <-- prop para forzar tamaño reducido
                  }) => {
    const isNoData =
        children === 'No hay datos' ||
        (typeof children === 'object' && children?.props?.message === 'No hay datos');

    let finalContent = children;

    // Normaliza decimales visibles en cards para evitar valores tipo 3.099999999999.
    // Si viene un número puro, se redondea a 2 decimales; si viene texto con unidad,
    // solo se corrigen los fragmentos decimales y se preserva la unidad.
    if (!isNoData) {
        if (typeof children === 'number') {
            finalContent = formatNumber(children, 2);
        } else if (typeof children === 'string') {
            finalContent = formatDecimalText(children, 2);
        }
    }

    return (
        <DataCardContainer smallVersion={smallVersion}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                {icon && <span style={{ marginRight: '8px', color }}>{icon}</span>}
                <DataCardTitle smallVersion={smallVersion}>{title}</DataCardTitle>
            </div>

            <DataCardValue smallVersion={smallVersion} color={isNoData ? '#B0B0B0' : undefined}>
                {isNoData ? <NoDataMessage message="No hay datos" /> : finalContent}
            </DataCardValue>

            {min !== undefined && max !== undefined && (
                <MinMaxContainer>
                    <div style={{ textAlign: 'center' }}>
                        <ArrowDownwardIcon style={{ color: 'green' }} />
                        <MinMaxValue color="green">
                            {min !== 'N/A' ? Number(min).toFixed(2) : 'N/A'}
                        </MinMaxValue>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                        <ArrowUpwardIcon style={{ color: 'red' }} />
                        <MinMaxValue color="red">
                            {max !== 'N/A' ? Number(max).toFixed(2) : 'N/A'}
                        </MinMaxValue>
                    </div>
                </MinMaxContainer>
            )}
        </DataCardContainer>
    );
};

export default DataCard;
